/**
 * Delete Community Use Case
 * Business logic for deleting a community
 */

import type { CommunitiesRepository } from '../data/communities-repository';

export class DeleteCommunityUseCase {
  constructor(private readonly repository: CommunitiesRepository) {}

  /**
   * Execute use case to delete a community
   * @param id - Community profile ID
   * @param hard - If true, permanent deletion; if false, soft delete (mark inactive)
   */
  async execute(id: number, hard: boolean = false): Promise<void> {
    try {
      // Validate profile ID
      if (!id || id <= 0) {
        throw new Error('Valid community ID is required');
      }

      await this.repository.deleteCommunity(id, hard);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to delete community';
      throw new Error(message);
    }
  }
}
